// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Label = require("./Form__Label.bs.js");
let InputStyles = require("./InputStyles.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

let prependAppendBase = "shrink-0 flex justify-center items-center \n    border-solid border-zinc-300 border rounded-sm bg-zinc-100 \n    text-zinc-700 min-w-9 py-1.5 text-base";

let Styles = {
  prependAppendBase: prependAppendBase
};

function Form__Input(props) {
  let id = props.id;
  let append = props.append;
  let prepend = props.prepend;
  let status = props.status;
  let ___type = props.type;
  let labelText = props.labelText;
  let _type = ___type !== undefined ? ___type : "text";
  return JsxRuntime.jsxs(ReactAriaComponents.TextField, {
    children: [
      labelText !== undefined ? JsxRuntime.jsx(Form__Label.make, {
          labelText: labelText,
          optionalText: props.optionalText,
          htmlFor: id
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          prepend !== undefined ? JsxRuntime.jsx("div", {
              children: prepend,
              className: TailwindMerge.twMerge([
                prependAppendBase,
                "border-r-0 rounded-r-none"
              ])
            }) : null,
          JsxRuntime.jsx(ReactAriaComponents.Input, {
            className: r => TailwindMerge.twMerge([
              InputStyles.baseInputStyles,
              InputStyles.inputStyles({
                isFocused: r.isFocused,
                isInvalid: r.isInvalid,
                isDisabled: r.isDisabled,
                status: status
              }),
              "h-9",
              prepend !== undefined ? "rounded-l-none" : "",
              append !== undefined ? "rounded-r-none" : "",
              "[&::-webkit-search-decoration]:appearance-none \n            [&::-webkit-search-cancel-button]:appearance-none \n            [&::-webkit-search-results-button]:appearance-none \n            [&::-webkit-search-results-decoration]:appearance-none"
            ]),
            ref: props.inputRef,
            onChange: props.onChange,
            onKeyDown: props.onKeyDown,
            onBlur: props.onBlur,
            onFocus: props.onFocus,
            autoFocus: props.autofocus,
            disabled: props.disabled
          }),
          append !== undefined ? JsxRuntime.jsx("div", {
              children: append,
              className: TailwindMerge.twMerge([
                prependAppendBase,
                "border-l-0 rounded-l-none"
              ])
            }) : null
        ],
        className: "flex flex-row"
      })
    ],
    className: _r => "flex flex-col",
    id: id,
    value: props.value,
    defaultValue: props.defaultValue,
    autoComplete: props.autocomplete,
    placeholder: props.placeholderText,
    type: _type === "text" ? "text" : (
        _type === "search" ? "search" : (
            _type === "number" ? "number" : "password"
          )
      ),
    inputMode: props.inputMode
  });
}

let make = Form__Input;

exports.Styles = Styles;
exports.make = make;
/* Form__Label Not a pure module */
